
kbd.Kbd {
    border-radius: 4px;
    font-weight: normal;
    font-size: .8rem;
    padding: 0;
    height: 1.1rem;

    > span {
        font-size: .8rem;
        padding: 0 .2rem;
        text-shadow: var(--soniq-t--global--text--shadow--contrast) -1px 1px 0;
    }

    + .Kbd {
        margin-left: .2em;
    }

    @media not all and (any-hover: hover) and (pointer: fine) {
        display: none;
    }
}

.Kbd__modifier {
    font-size: .7rem;
    margin-right: .2em;
}
